import { initialState, State, Action } from 'store/store';

export const loadBookmarkData = (
  state: State = initialState,
  { data }: Action
) => {
  const bookmarkLocation = data?.location ?? data;
  let bookmarkLoaded = true;

  if (data?.bookmarkLoaded !== undefined) {
    bookmarkLoaded = data?.bookmarkLoaded;
  }

  return {
    ...state,
    bookmarkLocation,
    bookmarkLoaded,
    // bookmarkLocation: data,
    // bookmarkLoaded: true,
  };
};
